import {handleLogout} from "components/utils"; import React, {createRef, useEffect, useRef, useState} from 'react';
import axios from "axios";
import {Accordion, Button, Card, Col, Modal, Nav, Row, Tab, Tabs} from "react-bootstrap";
import {ClientSelfView} from "./ClientSelfView";
import {OpdView} from "../../entity/opd/OpdView";
import {useCookies} from "react-cookie";
import {FutureBookingCalenderView} from "../FutureBookingCalenderView";
import {ReportsView} from "../reports/ReportsView";
import {EntityCustomerView} from "../../entity/opd/entityCustomer/EntityCustomerView";

export const ClientIndependentOpdView = (props: { cookiePhoneNumber: string, cookieQr: string,  qmeEnabled: boolean }) => {

    const [doctors, setDoctors] = useState<Array<any>>([])
    const [qmeEnabled, setQmeEnabled] = useState()
    const [entityQr, setEntityQr] = useState()
    const [cookies] = useCookies(['qme']);
    const [futureEnabled, setFutureEnabled] = useState(false)
    const [opd, setOpd] = useState<boolean>(false)

    useEffect(() => {
        // Perform localStorage action
        setOpd(localStorage.getItem('opd') == "true")
    }, [])

    useEffect(() => {
        if (props.cookieQr) {
            axios.get('/api/backend/user/client/profile?qrCode=' + props.cookieQr)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setEntityQr(resp.data.client.entityQrCode)
                    axios.get('/api/backend/entity/profile/' + resp.data.client.entityQrCode)
                        .then(resp => {
                            console.log(JSON.stringify(resp.data))
                            setQmeEnabled(resp.data.qmeEnabled)
                            const docs = resp.data.clientProfileEntities.filter(cp => cp.qrCode == props.cookieQr)
                            setDoctors(docs)
                            docs.map((profile) => {
                                axios.get('/api/backend/client/config/fetch/' + profile.qrCode)
                                    .then(resp => {
                                        if (resp.data) {
                                            setFutureEnabled((flag) => flag || resp.data.futureAppointments)
                                        }
                                    })
                                    .catch(err => {
                                        console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                                    })
                                    .finally(() => {
                                    })
                            })
                        })
                        .catch(err => {
                            console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                        })
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
                .finally(() => {

                })

            axios.get('/api/backend/client/config/fetch/' + props.cookieQr)
                .then(resp => {
                    if (resp.data) {
                        setFutureEnabled(resp.data.futureEnabled)
                    }
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
                .finally(() => {
                })
        }
    }, [props.cookieQr])

    return (
        <>

            < div className="d-lg-none">
                <Tabs
                    defaultActiveKey={!opd ? "patients" : "future"}
                    className="my-3 fs-6 text-secondary nav-pills"
                >
                    {futureEnabled && opd && <Tab eventKey="future" title="&#128197; Appointments">
                        <FutureBookingCalenderView doctors={doctors}/>
                    </Tab>}
                    {opd && <Tab eventKey="manage" title="&#128193; Reports">
                        <ReportsView doctors={doctors}/>
                    </Tab>}
                    <Tab eventKey="patients" title="&#128269; Search">
                        <EntityCustomerView cookieEntityQr={entityQr}/>
                    </Tab>
                </Tabs>
            </div>
            <div className="row d-none d-lg-block left-tabs">
                <Col>
                    <Tab.Container id="left-tabs" defaultActiveKey={!opd ? "patients" : "future"}>
                        <Row className="justify-content-center">
                            <Col sm={2} className="sidebar-menu">

                                <Nav variant="pills" className="flex-column">
                                    {futureEnabled && opd && <Nav.Item>
                                        <Nav.Link eventKey="future">Appointments</Nav.Link>
                                    </Nav.Item>}
                                    {opd && <Nav.Item>
                                        <Nav.Link eventKey="manage">Reports</Nav.Link>
                                    </Nav.Item>}
                                    <Nav.Item>
                                        <Nav.Link eventKey="patients">Search</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col sm={10}>
                                <Tab.Content>
                                    {futureEnabled && opd && <Tab.Pane eventKey="future">
                                        <FutureBookingCalenderView doctors={doctors}/>
                                    </Tab.Pane>}
                                    {opd && <Tab.Pane eventKey="manage">
                                        <ReportsView doctors={doctors}/>
                                    </Tab.Pane>}
                                    <Tab.Pane eventKey="patients">
                                        <EntityCustomerView cookieEntityQr={entityQr}/>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Col>
            </div>
        </>
    );
};

